import React from 'react';
import { MapPin, CheckCircle } from 'lucide-react';
import { serviceAreas } from '../data/mockData';

export const ServiceArea = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-green-500 to-green-700 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <MapPin className="w-4 h-4" />
            <span>Service Coverage</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Proudly Serving Nashville & Surrounding Areas
          </h2>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Professional tree care and landscaping services available throughout the greater Nashville metropolitan area.
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          {/* Google Map */}
          <div className="relative bg-white/10 backdrop-blur-md rounded-3xl p-4 md:p-8 mb-12 border-2 border-white/20">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              {/* Map Embed */}
              <div className="rounded-2xl overflow-hidden shadow-2xl h-[400px]">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d412849.4088242168!2d-87.05765765!3d36.1622296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8864ec3213eb903d%3A0x7d3fb9d0a1e9daa0!2sNashville%2C%20TN!5e0!3m2!1sen!2sus!4v1710892800000!5m2!1sen!2sus"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Service Area Map - Nashville and Surrounding Areas"
                  className="w-full h-full"
                ></iframe>
              </div>

              {/* Service Areas List */}
              <div>
                <div className="text-center lg:text-left mb-6">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-4 shadow-lg">
                    <MapPin className="w-8 h-8 text-green-600" />
                  </div>
                  <h3 className="text-2xl font-bold mb-2">Areas We Serve</h3>
                  <p className="text-white/90">Professional service throughout Middle Tennessee</p>
                </div>

                {/* Service Areas Grid */}
                <div className="grid grid-cols-2 gap-3">
                  {serviceAreas.map((area, index) => (
                    <div
                      key={area}
                      className="bg-white/20 backdrop-blur-sm rounded-xl p-3 text-center hover:bg-white/30 transition-all duration-300 transform hover:-translate-y-1"
                      style={{ animationDelay: `${index * 50}ms` }}
                    >
                      <CheckCircle className="w-5 h-5 mx-auto mb-1" />
                      <p className="font-semibold text-sm">{area}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Coverage Info */}
          <div className="grid md:grid-cols-3 gap-6 text-center max-w-5xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border-2 border-white/20">
              <div className="text-4xl font-bold mb-2">30+</div>
              <p className="text-white/90">Miles Coverage</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border-2 border-white/20">
              <div className="text-4xl font-bold mb-2">8+</div>
              <p className="text-white/90">Cities Served</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border-2 border-white/20">
              <div className="text-4xl font-bold mb-2">24/7</div>
              <p className="text-white/90">Emergency Tree Service</p>
            </div>
          </div>

          {/* CTA */}
          <div className="mt-12 text-center">
            <p className="text-xl mb-4">Don't see your area listed?</p>
            <p className="text-white/90 mb-6">Contact us to see if we can service your location!</p>
            <a
              href="tel:6159449032"
              className="inline-block bg-white text-green-600 font-bold px-8 py-4 rounded-lg hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 shadow-lg mr-4"
            >
              Call (615) 944-9032
            </a>
            <a
              href="tel:6153104173"
              className="inline-block bg-white/20 text-white font-bold px-8 py-4 rounded-lg hover:bg-white/30 transition-all duration-300 transform hover:scale-105 shadow-lg border-2 border-white/40"
            >
              Or (615) 310-4173
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
